import axios from "./axios";

export const getRequiredOffers = (city_id = undefined) => axios.get().get(`/required_offer`, {
  params: {
    ...(city_id || {})
  }
})
